var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightThird(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 295,
    height: 269,
    viewBox: "0 0 295 269",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14008_88944)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_14008_88944)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 295,
    height: 407,
    rx: 8,
    fill: "#EEF0FC"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 299,
    height: 44,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 59,
    width: 167,
    height: 8,
    rx: 1,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 16,
    y: 73,
    width: 220,
    height: 8,
    rx: 1,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 16,
    y: 89,
    width: 263,
    height: 8,
    rx: 1,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 121,
    width: 75,
    height: 8,
    rx: 1,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 16,
    y: 137,
    width: 148,
    height: 8,
    rx: 1,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 16,
    y: 169,
    width: 158,
    height: 8,
    rx: 1,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 16,
    y: 215,
    width: 165,
    height: 8,
    rx: 1,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 16,
    y: 185,
    width: 98,
    height: 8,
    rx: 1,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 16,
    y: 231,
    width: 98,
    height: 8,
    rx: 1,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 16,
    y: 201,
    width: 148,
    height: 8,
    rx: 1,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 16,
    y: 153,
    width: 165,
    height: 8,
    rx: 1,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.5,
    y: 121.5,
    width: 73,
    height: 123,
    rx: 3.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.5,
    y: 121.5,
    width: 73,
    height: 123,
    rx: 3.5,
    fill: "#2356F6",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.5,
    y: 121.5,
    width: 73,
    height: 123,
    rx: 3.5,
    stroke: "#2356F6",
    strokeLinecap: "round",
    strokeDasharray: "2 5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M221.204 153.128C222.548 153.128 223.636 152.44 223.956 151.384V153H226.452V148.472C226.452 147.64 225.844 146.712 224.708 146.712H221.556V148.792H223.556C223.716 148.792 223.812 148.904 223.812 149.08C223.812 149.864 222.564 150.856 221.364 150.856C219.684 150.856 218.324 149.464 218.324 147.4C218.324 145.336 219.684 144.104 221.412 144.104C222.74 144.104 223.556 144.792 223.7 145.88H226.484C226.388 143.384 224.356 141.672 221.444 141.672C218.404 141.672 215.636 143.576 215.636 147.4C215.636 151.224 218.308 153.128 221.204 153.128ZM227.908 153H230.548V144.936H227.908V153ZM227.86 143.944H230.612V141.352H227.86V143.944ZM234.258 153H236.594L239.538 144.936H236.85L235.426 149.624L233.986 144.936H231.314L234.258 153ZM240.298 153H242.938V144.936H240.298V153ZM240.25 143.944H243.002V141.352H240.25V143.944ZM244.376 153H247.016V148.552C247.016 147.752 247.576 147.144 248.376 147.144C249.176 147.144 249.736 147.752 249.736 148.552V153H252.376V147.928C252.376 146.136 251.192 144.808 249.384 144.808C248.328 144.808 247.48 145.24 247.016 145.864V144.936H244.376V153ZM257.334 153.128C258.166 153.128 258.918 152.84 259.35 152.312V153.208C259.35 153.816 258.966 154.248 258.438 154.248H254.726V156.264H258.918C260.774 156.264 261.974 155.192 261.974 153.528V144.936H259.334V145.576C258.902 145.112 258.23 144.808 257.286 144.808C255.014 144.808 253.558 146.392 253.558 148.968C253.558 151.544 255.014 153.128 257.334 153.128ZM256.134 148.968C256.134 147.8 256.79 147.048 257.798 147.048C258.822 147.048 259.478 147.8 259.478 148.968C259.478 150.136 258.822 150.888 257.798 150.888C256.79 150.888 256.134 150.136 256.134 148.968ZM220.703 173H223.551V168.648H227.519V166.216H223.551V164.232H228.591V161.8H220.703V173ZM232.898 173.128C235.41 173.128 237.218 171.352 237.218 168.968C237.218 166.584 235.41 164.808 232.898 164.808C230.386 164.808 228.578 166.584 228.578 168.968C228.578 171.352 230.386 173.128 232.898 173.128ZM231.218 168.968C231.218 167.816 231.89 167.048 232.898 167.048C233.906 167.048 234.578 167.816 234.578 168.968C234.578 170.12 233.906 170.888 232.898 170.888C231.89 170.888 231.218 170.12 231.218 168.968ZM242.291 167.112H243.699V164.936H242.851C241.955 164.936 241.363 165.192 240.899 166.152V164.936H238.259V173H240.899V168.92C240.899 167.784 241.411 167.112 242.291 167.112ZM244.634 173H247.274V168.488C247.274 167.592 247.77 167.016 248.522 167.016C249.274 167.016 249.77 167.592 249.77 168.488V173H252.41V168.488C252.41 167.592 252.906 167.016 253.658 167.016C254.41 167.016 254.906 167.592 254.906 168.488V173H257.546V167.64C257.546 166.152 256.378 164.808 254.618 164.808C253.29 164.808 252.314 165.464 251.882 166.168C251.45 165.288 250.73 164.808 249.498 164.808C248.474 164.808 247.754 165.256 247.274 165.896V164.936H244.634V173Z",
    fill: "#2356F6"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 294,
    height: 268,
    rx: 7.5,
    stroke: "#DADCE8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_14008_88944",
    x: -34,
    y: -30,
    width: 363,
    height: 475,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14008_88944"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14008_88944",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14008_88944"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 295,
    height: 269,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightThird);
export default __webpack_public_path__ + "static/media/RightThird.4ecf9438987ee4b3ad0c9113f0407517.svg";
export { ForwardRef as ReactComponent };